import ClientLogo from "@/components/common/ClientLogo";
import CounterComponent from "@/components/common/CounterComponent";
import PagesHeader from "@/components/common/PagesHeader";
import PrimaryButton from "@/components/common/PrimaryButton";
import Layout from "@/components/layout/Layout";
import Commitment from "@/components/services/Commitment";
import DetailCard from "@/components/services/DetailCard";
import { COUNTER_DATA, LINK_OF_ALL_PAGES } from "const/common";
import Image from "next/image";
import Link from "next/link";

const SERVICES_LAYOUT_TITLE =
  "Software Development Services | ultroNeous Technologies";
const SERVICES_LAYOUT_DESCRIPTION =
  "A Software Development Company with expertise in Web & Mobile App Development providing Software Development Services.";
const ServicePage = () =>
{
  return (
    <Layout
      canonicalLink="https://ultroneous.com/services"
      description={SERVICES_LAYOUT_DESCRIPTION}
      keywords="Software Development Service"
      ogDescription={SERVICES_LAYOUT_DESCRIPTION}
      ogImage="https://ultroneous.com/assets/services/meeting.webp"
      ogTitle={SERVICES_LAYOUT_TITLE}
      ogUrl="https://ultroneous.com/services"
      title={SERVICES_LAYOUT_TITLE}
      twitterDescription={SERVICES_LAYOUT_DESCRIPTION}
      twitterImage="https://ultroneous.com/assets/services/meeting.webp"
      twitterTitle={SERVICES_LAYOUT_TITLE}
    >
      <PagesHeader
        heading="360° solutions for all your IT needs"
        text="Services"
      />
      {/* starting paragraph */}
      <div className="bg-primary-black">
        <p className="text-justify md:text-center text-white mx-auto mb-2 text-sm md:text-lg xl:w-3/5 pt-4 md:pt-1 pb-6 px-4 md:px-8 [&>a]:text-deep-sky-blue">
          <span>
            Be it a software development services for website & mobile app
            development, be it a&nbsp;
            <Link href={LINK_OF_ALL_PAGES.services.uiUXDesignServices}>
              <a className="text-blue-500">UI/ UX designing</a>
            </Link>
            &nbsp; with wireframe and prototyping or be a solution provider for
            your product with various business models; ultroNeous is your one
            stop solution. We are a full fledged software development and
            consulting firm with a rich technical expertise and proven business
            experience. Our talented ultroNeours will cover everything from the
            early stages of ideation, designing, tech stack consultation,
            development and post launch marketing.
          </span>
        </p>
        <DetailCard />
        <div className="text-center py-8 px-4 md:py-16 md:px-10">
          <h2 className="fw-normal text-white mb-2 text-2xl md:text-4xl md:leading-snug">
            <span>
              Not sure what service you need?
              <br />
              Let us carefully analyze your business situation
              <br />
              and goals to offer you a proper solution.
            </span>
          </h2>
          <div className="flex justify-center pt-6">
            <PrimaryButton
              link={LINK_OF_ALL_PAGES.mainPages.contactUs}
              val="Talk to an Expert"
            />
          </div>
        </div>
        <div className="py-8 md:py-16">
          <ClientLogo />
        </div>
        <div className="fs-0 py-8 px-4 md:py-16 md:px-10">
          <Image
            alt="Services Discusson"
            height={800}
            objectFit="cover"
            src="/assets/services/meeting.webp"
            title="Services Discusson"
            width={1900}
          />
        </div>
        <div className="pb-16">
          <h2 className="font-normal text-white text-center pt-0 md:pt-12 mx-4 md:mx-0 my-0 md:mt-4 text-3xl md:text-6xl">
            <span>Reasons to work with ultroNeous</span>
          </h2>
          <CounterComponent
            data={COUNTER_DATA}
            mainContainerClass="w-full md:justify-start lg:justify-evenly py-16 px-4 md:px-10"
            secondMainContainerClass="lg:w-2/12 md:items-center xl:flex xl:flex-col"
          />
        </div>
      </div>
      <div className="py-8 px-4 md:py-16 md:px-10">
        <h2 className="font-normal text-center pt-0 pb-2 md:pb-0 md:pt-6 mt-2 mb-4 text-3xl md:text-6xl">
          <span>Our Commitments</span>
        </h2>
        <p className="xl:w-1/2 mx-auto text-center text-black text-base mb-4 pb-2 md:mb-0 md:pb-0 [&>a]:text-deep-sky-blue">
          <span>
            When you decide to work with ultroNeous, not only you get access
            to&nbsp;
            <Link href={LINK_OF_ALL_PAGES.mainPages.home}>
              <a className="text-blue-500">software development services</a>
            </Link>
            &nbsp; but also as we honor the responsibility of taking care of
            your project, you get a meaningful partnership. Our unwavering
            commitment and drive for innovation balances the performance with
            creativity. We promise and we mean to fulfill each of our
            commitments to make your project journey easy and successful.
          </span>
        </p>
        <Commitment />
      </div>
    </Layout>
  );
};

export default ServicePage;
